import { Tabbar } from '@telegram-apps/telegram-ui';

import {
  ChatIcon,
  GiftIcon,
  SettingsIcon,
  TrophyIcon,
} from '../ui/icons.js';
import { useT } from '../hooks/useT.js';
import styles from './BottomTabbar.module.css';

/** Верхнеуровневые вкладки нижней навигации. */
export type TabKey = 'INBOX' | 'LEADERBOARD' | 'REWARDS' | 'SETTINGS';

/**
 * Временно скрываем вкладку «Лидерборд» (по просьбе владельца — откроем позже).
 * Код экрана LeaderboardScreen и роутинг 'LEADERBOARD' НЕ удалены: чтобы вернуть
 * вкладку — поставь `true`. Скрыта только кнопка в нижней навигации.
 */
const SHOW_LEADERBOARD = false;

const ALL_TABS: ReadonlyArray<{
  key: TabKey;
  Icon: (props: { width?: number; height?: number }) => JSX.Element;
  labelKey: 'tab_questions' | 'tab_leaderboard' | 'tab_rewards' | 'tab_settings';
}> = [
  { key: 'INBOX', Icon: ChatIcon, labelKey: 'tab_questions' },
  { key: 'LEADERBOARD', Icon: TrophyIcon, labelKey: 'tab_leaderboard' },
  { key: 'REWARDS', Icon: GiftIcon, labelKey: 'tab_rewards' },
  { key: 'SETTINGS', Icon: SettingsIcon, labelKey: 'tab_settings' },
];

const TABS = ALL_TABS.filter(
  (tab) => SHOW_LEADERBOARD || tab.key !== 'LEADERBOARD',
);

interface BottomTabbarProps {
  active: TabKey;
  onSelect: (tab: TabKey) => void;
}

/**
 * Нижняя навигация (нативный kit `Tabbar`, фиксируется внизу через FixedLayout).
 * Показывается только на верхнеуровневых экранах; под-потоки ASK/ANSWER/SHARE
 * её не рендерят (App.tsx). Иконки 28×28 по контракту TabbarItem.
 */
export function BottomTabbar({ active, onSelect }: BottomTabbarProps) {
  const t = useT();
  return (
    <Tabbar className={styles.tabbar}>
      {TABS.map((tab) => (
        <Tabbar.Item
          key={tab.key}
          text={t[tab.labelKey]}
          selected={active === tab.key}
          onClick={() => onSelect(tab.key)}
        >
          <tab.Icon width={28} height={28} />
        </Tabbar.Item>
      ))}
    </Tabbar>
  );
}
